import BaseCartesianGrid from "../../sisu/chart/BaseCartesianGrid.sisu";

const NeoCartesianGrid = BaseCartesianGrid

export default NeoCartesianGrid